const initialState = {}

function LoginReduceruser(state = initialState, action) {
    switch (action.type) {
        case 'LOGINUSER':
            return action.data
        default:
            return state
    }
}
export default LoginReduceruser